import React from "react";
import { COUNTRIES } from "@common/countries";
import { invoiceCountryCode } from "@common/helpers/nativeInvoice";
import { STATES_LIST } from "@common/states";
import { Field } from "@design-system/Field/Field";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

const STATE_ITEMS: Array<PickerItemData<string>> = STATES_LIST.map((state) => ({
    value: state.abbreviation,
    label: state.name,
}));
const COUNTRY_ITEMS: Array<PickerItemData<string>> = COUNTRIES.map(
    (country) => ({ value: country.code, label: country.name }),
);

export function InvoiceAddressStateField({
    value,
    onChange,
}: {
    value: string;
    onChange: (value: string) => void;
}) {
    return (
        <Field label="State" control="button">
            <Picker.Select
                items={STATE_ITEMS}
                searchable
                searchPlaceholder="Search states..."
                emptyLabel="No matching states"
                value={value || null}
                onValueChange={(nextValue) => {
                    onChange(nextValue ?? "");
                }}
                placeholder="Select"
                clearable
                trigger={<Picker.Button variant="primary" size="xl" block />}
            />
        </Field>
    );
}

export function InvoiceAddressCountryField({
    value,
    onChange,
}: {
    value: string;
    onChange: (value: string) => void;
}) {
    const selectedCode = invoiceCountryCode(value) || null;

    return (
        <Field label="Country" control="button">
            <Picker.Select
                items={COUNTRY_ITEMS}
                searchable
                searchPlaceholder="Search countries..."
                emptyLabel="No matching countries"
                value={selectedCode}
                onValueChange={(nextValue) => {
                    onChange(nextValue ?? "");
                }}
                placeholder="Select"
                clearable
                trigger={<Picker.Button variant="primary" size="xl" block />}
            />
        </Field>
    );
}
